export default __webpack_public_path__ + "static/assets/SL-triangle-white-opaque.0a3e476f.png";